<template>
    <div class="wrap">
        <div class="container lnb">
            <div class="contents_wrap">
                <div class="contents">
                    <div class="tab">
                        <div class="tab_wrap">
                            <div class="t_txt" :class="{'active' : tabIdx === 1}" @click="changeTab(1)">기본정보</div>
                            <div class="t_txt" :class="{'active' : tabIdx === 2}" @click="changeTab(2)">문의내역</div>
                            <div class="t_txt" :class="{'active' : tabIdx === 3}" @click="changeTab(3)">게시물</div>
<!--                            <div class="t_txt" :class="{'active' : tabIdx === 4}" @click="changeTab(4)">오늘 게시물</div>-->
                            <div class="t_txt" :class="{'active' : tabIdx === 5}" @click="changeTab(5)">포인트</div>
                            <div class="t_txt" :class="{'active' : tabIdx === 6}" @click="changeTab(6)">구매기록</div>
                            <div class="clear"></div>
                        </div>
                    </div>
                    <div class="tab_content" v-show="tabIdx === 1">
                        <div class="title">
                            기본설정
                            <div class="clear"></div>
                        </div>
                        <member-write-component :memberType="'updateMember'"
                                                :memberKey="memberKey"></member-write-component>
                    </div>
                    <div v-if="tabIdx === 2" class="tab_content">
                        <board-list-component :boardType="'memberQa'" :defaultFilter="{'no': memberKey}"></board-list-component>
                    </div>
                    <div v-if="tabIdx === 3" class="tab_content">
                        <feed-list-component :feedType="'memberFeed'" :defaultFilter="{'mbno': memberKey}"></feed-list-component>
                    </div>
                    <div v-if="tabIdx === 4" class="tab_content">
                        <today-list-component :todayType="'memberToday'" :defaultFilter="{'mbno': memberKey}"></today-list-component>
                    </div>
                    <div v-if="tabIdx === 5" class="tab_content">
                        <point-store-component :memberKey="memberKey"></point-store-component>
                        <point-save-component :memberKey="memberKey"></point-save-component>
                        <point-list-component :pointType="'point'" :defaultFilter="{'no': memberKey}"></point-list-component>
                    </div>
                    <div v-if="tabIdx === 6" class="tab_content">
                        <order-list-component :orderType="'memberOrderHistory'" :memberKey="memberKey" :defaultParams="defaultParams"></order-list-component>
                    </div>
                </div>
                <page-footer></page-footer>
            </div>
        </div>
    </div>
</template>

<script>

import MemberWriteComponent from "@/components/member/MemberWriteComponent";
import alertMixins from "@/mixins/alertMixins";
import BoardListComponent from "@/components/board/BoardListComponent";
import FeedListComponent from "@/components/feed/FeedListComponent";
import TodayListComponent from "@/components/today/TodayListComponent";
import PointSaveComponent from "@/components/point/PointSaveComponent";
import PointStoreComponent from "@/components/point/PointStoreComponent";
import PointListComponent from "@/components/point/PointListComponent";
import OrderListComponent from "@/components/order/OrderListComponent";
import util from "../../mixins/util";

export default {
    name: 'MemberDetail',
    components: {
        PointListComponent,
        PointStoreComponent,
        PointSaveComponent,
        TodayListComponent,
        FeedListComponent,
        BoardListComponent,
        MemberWriteComponent,
        OrderListComponent
    },
    mixins: [alertMixins],
    provide() {
        return {}
    },
    data() {
        return {
            memberKey: this.$route.params.mb_no,
            tabIdx: 1,
            defaultParams:{
                no : this.$route.params.mb_no
            },
        }
    },
    created() {
        if(!util.isEmpty(this.$route.query.tab) && !isNaN(this.$route.query.tab)) {
            this.tabIdx = Number(this.$route.query.tab);
        }
    },
    mounted() {
    },
    methods: {
        changeTab(idx) {
            this.tabIdx = idx;
            this.$router.replace(`${this.$route.path}?tab=${idx}`);
        },
    },
    watch: {}
}
</script>

<style>

</style>
